/* global define */

define([
  'es6!sumo/util',
  'immutable',
  'es6!launcher/actions/ecommerce/EcommerceActions',
], (Util, Immutable, Actions) => {
  const initialState = Immutable.Map({
    collections: Immutable.List(),
    productsByCollection: Immutable.Map(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.RECEIVE_SHOPIFY_PRODUCTS] = (state, action) => {
    const {
      products,
      collectionId = 'all',
    } = action;

    return state.setIn(['productsByCollection', collectionId], Immutable.fromJS(products));
  };

  actionHandlers[Actions.RECEIVE_SHOPIFY_COLLECTIONS] = (state, action) => {
    const { collections } = action;
    return state.set('collections', Immutable.fromJS(collections));
  };

  return Util.createReducer(initialState, actionHandlers);
});
